import React, { useMemo } from 'react'
import { View, Text, Pressable, Platform } from 'react-native'
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations'
import Svg, { Path } from 'react-native-svg'
import { useTheme } from '../../../src/theme/useTheme'
import {
  buildNotificationBadgeLabel,
  buildNotificationBellA11yLabel,
} from './NotificationBell.helper'
import { getNotificationBellStyles } from './NotificationBell.styles'

interface NotificationBellProps {
  unreadCount: number
  onPress: () => void
  testID?: string
}

export const NotificationBell: React.FC<NotificationBellProps> = ({
  unreadCount,
  onPress,
  testID = 'notification-bell',
}) => {
  const theme = useTheme()
  const styles = useMemo(() => getNotificationBellStyles(theme), [theme])

  const badgeLabel = buildNotificationBadgeLabel(unreadCount)

  return (
    <Pressable
      style={({ pressed, hovered }) => [
        styles.container,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.containerPressed,
        hovered && Platform.OS === 'web' && styles.containerHover,
      ]}
      onPress={onPress}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      accessibilityRole="button"
      accessibilityLabel={buildNotificationBellA11yLabel(unreadCount)}
      testID={testID}
    >
      <Svg width={22} height={22} viewBox="0 0 24 24" fill="none">
        <Path
          d="M12 2C10.343 2 9 3.343 9 5V5.29C6.718 6.148 5 8.389 5 11V16L3 18V19H21V18L19 16V11C19 8.389 17.282 6.148 15 5.29V5C15 3.343 13.657 2 12 2ZM12 4C12.552 4 13 4.448 13 5V5.07C12.67 5.03 12.338 5 12 5C11.662 5 11.33 5.03 11 5.07V5C11 4.448 11.448 4 12 4ZM10 20C10 21.1 10.9 22 12 22C13.1 22 14 21.1 14 20H10Z"
          fill={theme.primary}
        />
      </Svg>
      {unreadCount > 0 && (
        <View style={styles.badge}>
          <Text style={styles.badgeText}>{badgeLabel}</Text>
        </View>
      )}
    </Pressable>
  )
}
